/**
 * i18n bootstrap — international-first architecture.
 * Priority order:
 *   1. Explicit localStorage.kosyam_lang (user picked before)
 *   2. Browser navigator.language starting with 'en' → 'en'
 *   3. Fallback 'fr'
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "@/locales/fr/common.json";
import en from "@/locales/en/common.json";

const SUPPORTED = ["fr", "en"];

function detectInitialLanguage() {
  if (typeof window === "undefined") return "fr";
  try {
    const saved = localStorage.getItem("kosyam_lang");
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (e) { /* ignore */ }
  const navLangs = [
    ...(navigator.languages || []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean);
  for (const l of navLangs) {
    const short = l.toLowerCase().slice(0, 2);
    if (SUPPORTED.includes(short)) return short;
  }
  return "fr";
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: fr },
      en: { common: en },
    },
    lng: detectInitialLanguage(),
    fallbackLng: "fr",
    defaultNS: "common",
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

// Persist choice for next visit
if (typeof window !== "undefined") {
  i18n.on("languageChanged", (lng) => {
    try { localStorage.setItem("kosyam_lang", lng); } catch (e) { /* ignore */ }
    document.documentElement.setAttribute("lang", lng);
  });
  document.documentElement.setAttribute("lang", i18n.language);
}

export default i18n;
